import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../utils/axiosInstance';
import './RegistrationRequests.css';
import { IoIosArrowBack } from 'react-icons/io';
import format from 'date-fns/format';
import { Spinner, Alert } from 'react-bootstrap';

const RegistrationRequests = ({ loggedInEmployeeId, empRole, companyId }) => {
    const { t } = useTranslation();
    const [requests, setRequests] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(''); // Initialize the dropdown state
    const [loading, setLoading] = useState(true); // Loading state
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const fetchRequests = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get('/admin/registrationReq', companyId ? { params: { companyId } } : undefined);
                const allRequests = response.data;

                // Filter requests based on the employee's role
                if (empRole === 'SuperAdmin') {
                    setRequests(allRequests); // Show all info for AdminID
                } else if (loggedInEmployeeId === 14569 || loggedInEmployeeId === 14570) {
                    setRequests(allRequests.filter(request => request.company_id === companyId)); // Show company specific info
                } else {
                    setRequests(allRequests.filter(request => request.admin_id === loggedInEmployeeId)); // Show specific info to logged in admin
                }
            } catch (error) {
                console.error('Error fetching registration requests:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRequests();
    }, [loggedInEmployeeId, empRole, companyId, location.state?.refresh]);

    const handleRequestClick = (request) => {
        navigate(`/request-details/${request.id}`, { state: { request, loggedInEmployeeId, empRole } });
    };

    const handleBackClick = () => {
        navigate('/ManageEmployees');
    };

    // Filter requests based on the selected dropdown option
    const filteredRequests = selectedStatus
        ? requests.filter(request => request.registration_status.toLowerCase() === selectedStatus.toLowerCase())
        : requests; // Show all requests if no status is selected

    return (
        <div className="registration-requests-container">
            <button className="backButton" onClick={handleBackClick}>
                <IoIosArrowBack style={{ marginRight: '5px' }} /> {t("projectDetails_back")}
            </button>
            <h2>{t("Registration Requests")}</h2>

            <div className='search-bar'>
                <select
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    className="status-dropdown"
                >
                    <option value="">{t("Show all")}</option>
                    <option value="Pending">{t("Pending")}</option>
                    <option value="Declined">{t("Approved")}</option>
                    <option value="In-Review">{t("In-Review")}</option>
                </select>
            </div>
            <table className='reqTable'>
                <thead>
                    <tr>
                        <th>{t("Full Name")}</th>
                        <th>{t("Admission Date")}</th>
                        <th>{t("Application Status")}</th>
                    </tr>
                </thead>
                {loading ? (
                    <tbody style={{ background: '#fff' }}>
                        <tr>
                            <td className="table-data-row"></td>
                            <td className="employee-table-Spinner table-data-row">
                                <Spinner animation="border" role="status">
                                    <span className=""></span>
                                </Spinner><br />
                                <span className="mt-2">{t('Please wait your data is loading')}</span>
                            </td>
                            <td className="table-data-row"></td>
                        </tr>
                    </tbody>
                ) : filteredRequests.length === 0 ? (
                    <tbody style={{ background: '#fff' }}>
                        <tr>
                            <td className="table-data-row"></td>
                            <td className="table-data-row">
                                <Alert variant="light" className='employee-table-Alert'>
                                    {t("No employees found")}
                                </Alert>
                            </td>
                            <td className="table-data-row"></td>
                        </tr>
                    </tbody>
                ) : (
                    <tbody>
                        {filteredRequests.map(request => (
                            <tr key={request.id} onClick={() => handleRequestClick(request)}>
                                <td>{request.full_name}</td>
                                <td>{format(request.admission_date, 'dd/MM/yyyy')}</td>
                                <td className={`status-${request.registration_status.toLowerCase()}`}>
                                    {t(`${request.registration_status}`)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                )}
            </table>
        </div>
    );
};

export default RegistrationRequests;
